


/**
 * Checks if the code is running in a browser environment.
 */
export const isClient = () => typeof window !== 'undefined';